import { getFramework } from '@/framework';
import type { RulerBar } from '../ruler-bar';
import { getRulerState } from '../states/ruler-state';

export function setRulerBarVisibility(identity: string, show: boolean) {
    const framework = getFramework(identity);
    const setShowRulerBar = getRulerState(identity).setShowRulerBar;
    setShowRulerBar(show);
    framework.service.registration.getInstance<RulerBar>('RulerBar').emitShowRulerBarChanged(show);
}
